// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-module__linkPadding___zuJPG {\n  padding: 8px 16px;\n  flex-grow: 0 !important;\n  font-size: 14px;\n}", "",{"version":3,"sources":["webpack://./src/utils/ErrorPage/index.module.css"],"names":[],"mappings":"AAAA;EACE,iBAA0B;EAC1B,uBAAuB;EACvB,eAAqB;AACvB","sourcesContent":[".linkPadding {\n  padding: units(2) units(4);\n  flex-grow: 0 !important;\n  font-size: units(3.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkPadding": "index-module__linkPadding___zuJPG"
};
module.exports = ___CSS_LOADER_EXPORT___;
